import React, { useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Page from "../../Page";
import CreateContestModal from "./CreateContest";
import { createContest, fetchContest, updateContest } from "../../../redux/actions/ContestAction";
import Loading from "../../Loading";
import "./Contests.css";

const CreateContestPage = (props) => {
  props.pageTypeHandler?.("Contests");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id: editId } = useParams();
  const location = useLocation();
  const authToken = props.authToken;
  const isLoading = useSelector((state) => state.contest.loading);
  const contestData = useSelector((state) => state.contest.contest);

  // Fetch contest data when editId exists
  // Always fetch from API to ensure fresh data, even if location.state has contest data
  useEffect(() => {
    // Only fetch if we have editId
    if (!editId) {
      return;
    }
    
    // Wait for authToken to be available
    if (!authToken) {
      return;
    }
    
    // Always fetch from API when editId exists
    // This ensures we have the latest data, especially on page reload
    // location.state is just used for initial render while API call is in progress
    dispatch(fetchContest(authToken, editId));
  }, [editId, authToken, dispatch]);

  const handleClose = () => {
    navigate("/contests");
  };

  const handleSave = (apiPayload) => {
    if (!authToken) return;
    const onSuccess = () => navigate("/contests");
    if (editId) {
      dispatch(updateContest(authToken, apiPayload, onSuccess));
    } else {
      dispatch(createContest(authToken, apiPayload, onSuccess));
    }
  };

  // Use fetched contest data if available, otherwise use location state
  // API response structure: { status: true, message: "...", data: { id, contest_name, ... } }
  // But we store only the data part in Redux, so contestData should be { id, contest_name, ... }
  // PRIORITY: Use Redux contestData (raw API response) over location.state (transformed data)
  const getContestData = () => {
    // For create flow (no editId in URL), always start with blank data
    // and ignore any stale contest data that might be in Redux or location.state.
    if (!editId) {
      return null;
    }

    // First priority: Use Redux contestData (raw API response with milestones)
    if (contestData) {
      // contestData should already be the contest object (data part extracted in action)
      // But handle both cases just in case
      const data = contestData.id ? contestData : contestData.data || null;
      // Only use Redux data if it has contest_name (raw API format) or milestones
      if (data && (data.contest_name || data.milestones)) {
        console.log("CreateContestPage - Using Redux contestData (raw API):", data);
        console.log("CreateContestPage - milestones in Redux data:", data?.milestones);
        return data;
      }
    }
    // Second priority: Use location.state (transformed data from navigation)
    if (location.state?.contest) {
      console.log("CreateContestPage - Using location.state.contest (transformed):", location.state.contest);
      return location.state.contest;
    }
    // Fallback: Just the ID
    return editId ? { id: editId } : null;
  };
  const contestToEdit = getContestData();
  console.log("CreateContestPage - contestToEdit:", contestToEdit);

  return (
    <Page title={props.title || (contestToEdit?.id ? "Edit Contest" : "Create Contest")}>
      {isLoading && <Loading />}
      <div className="create-contest-page">
        <CreateContestModal
          editContest={contestToEdit}
          authToken={authToken}
          onClose={handleClose}
          onSave={handleSave}
          asPage={true}
        />
      </div>
    </Page>
  );
};

export default CreateContestPage;
